module.exports = __webpack_public_path__ + "img/cons_5.2cd5f78b.jpg";